<template>
  <div>
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
          <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
      </template>
      <v-layout row>
          <v-flex xs12>
              <v-card>
                  <progress-bar :show="form.busy"></progress-bar>
                  <form @submit.prevent="createPerson" @keydown="form.onKeydown($event)">
                      <v-card-title primary-title>
                          <h3 v-if="!editingPerson" class="headline mb-0">Nueva persona a cargo</h3>
                          <h3 v-else class="headline mb-0">Editar persona a cargo</h3>
                      </v-card-title>

                      <v-card-text>
                          <text-input
                            :form="form"
                            :label="$t('register_form.first_name')"
                            :v-errors="errors"
                            :value.sync="form.first_name"
                            counter="30"
                            name="first_name"
                            v-validate="'required|max:30'"
                          ></text-input>

                          <text-input
                            :form="form"
                            :label="$t('register_form.middle_name')"
                            :v-errors="errors"
                            :value.sync="form.middle_name"
                            name="middle_name"
                          ></text-input>

                          <text-input
                            :form="form"
                            :label="$t('register_form.last_name_1')"
                            :v-errors="errors"
                            :value.sync="form.last_name_1"
                            counter="30"
                            name="last_name_1"
                            v-validate="'required|max:30'"
                          ></text-input>

                          <text-input
                            :form="form"
                            :label="$t('register_form.last_name_2')"
                            :v-errors="errors"
                            :value.sync="form.last_name_2"
                            counter="30"
                            name="last_name_2"
                            v-validate="'required|max:30'"
                          ></text-input>

                            <select-input
                              :form="form"
                              :items="genders"
                              :label="$t('register_form.gender')"
                              :v-errors="errors"
                              :value.sync="form.gender"
                              name="gender"
                              v-validate="'required'"
                            ></select-input>

                          <select-input
                            :form="form"
                            :items="nit_types"
                            :label="$t('register_form.nit_type')"
                            :v-errors="errors"
                            :value.sync="form.nit_type"
                            name="nit_type"
                            v-validate="'required'"
                          ></select-input>

                          <text-input
                            :form="form"
                            :label="$t('register_form.nit')"
                            :v-errors="errors"
                            :value.sync="form.nit"
                            counter="15"
                            name="nit"
                            v-validate="'required|max:30'"
                          ></text-input>

                          <date-picker
                            :form="form"
                            :label="$t('register_form.birth_date')"
                            :v-errors="errors"
                            :value.sync="form.birth_date"
                            name="birth_date"
                            v-validate="'required'"
                          ></date-picker>


                      </v-card-text>

                      <v-card-actions>
                          <submit-button
                            v-if="!editingPerson"
                            :form="form" label="Guardar"></submit-button>
                          <submit-button v-else :form="form" label="Actualizar"></submit-button>
                          <v-btn @click="cancelFormSubmit" >Cancelar</v-btn>
                      </v-card-actions>
                  </form>
              </v-card>
          </v-flex>
      </v-layout>
    </v-dialog>
    <v-layout row wrap>
      <v-flex xs12>
        <h3>Esta opción es únicamente para registrar estudiantes que NO son del Columbus School.</h3>
      </v-flex>
      <v-flex xs12 >
        <v-data-table
          :headers="headers"
          :items="persons"
          class="elevation-1 mt-3"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.first_name }}</td>
            <td class="text-xs-center">{{ props.item.middle_name }}</td>
            <td class="text-xs-center">{{ props.item.last_name_1 }}</td>
            <td class="text-xs-center">{{ props.item.last_name_2 }}</td>
            <td class="text-xs-center">{{ props.item.gender }}</td>
            <td class="text-xs-center">{{ props.item.birth_date }}</td>
            <td class="text-xs-center">{{ props.item.nit_type }}</td>
            <td class="text-xs-center">{{ props.item.nit }}</td>
            <td>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="editPerson(props.item.id)"
                  slot="activator"
                >
                  edit
                </v-icon>
                <span>Editar</span>
              </v-tooltip>
              <v-tooltip top>
                <v-icon
                  medium
                  class="mr-2"
                  @click="deletePerson(props.item.id)"
                  slot="activator"
                >
                  delete
                </v-icon>
                <span>Eliminar</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
    import Form from 'vform';
    import axios from 'axios';



    export default {
        name: 'enrollment-cost-create-view',

        data() {
          return {
            form: new Form({
                first_name: '',
                middle_name: '',
                last_name_1: '',
                last_name_2: '',
                birth_date: '',
                nit_type: '',
                nit: '',
                busy: false
            }),
            enrollments: [],
            gradesOptions:  [],
            headers: [
              { text: 'Primer nombre', align: 'center', value: 'first_name' },
              { text: 'Seg. nomb', align: 'center', value: 'middle_name' },
              { text: 'Prim. Apellido', align: 'center', value: 'last_name_1' },
              { text: 'Seg. apell', align: 'center', value: 'last_name_2' },
              { text: 'Género', align: 'center', value: 'gender' },
              { text: 'Nacimiento', align: 'center', value: 'birth_date' },
              { text: 'Tipo ID', align: 'center', value: 'nit_type'},
              { text: 'ID', align: 'center', value: 'nit'},
              { text: 'Acciones', align: 'center', value: 'acciones' }
            ],
            persons: [],
            editingPerson: false,
            dialog: false,
            nit_types: [
              { value: 'CC', text: 'Cedula de ciudadania' },
              { value: 'TI', text: 'Tarjeta de identidad' },
              { value: 'CE', text: 'Cedula de extranjeria' },
              { value: 'RC', text: 'Registro civil' },
            ],
            genders: [
              { value: 'M', text: 'Masculino' },
              { value: 'F', text: 'Femenino' },
            ],
          }
        },
        created() {
          this.init();
        },
        methods: {
            init() {
              axios.get('/api/user/dependant_persons')
                .then(resp => {
                  if (resp.status === 200) {
                    this.persons = resp.data
                  }
                })
                .catch(err => console.log(err))
            },
            async createPerson() {
                if (await this.formHasErrors()) return
                if (this.editingPerson) {
                  this.updatePerson();
                  return
                }
                const { data, status } = await this.form.post('/api/user/dependant_persons')

                if (status === 200) {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: 'Guardado correctamente',
                        title: 'Correcto',
                        modal: false
                    })
                    this.cancelFormSubmit()
                    this.init();
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: 'Error al guardar el registro',
                        title: 'Alerta',
                        modal: true
                    })
                }
            },
            async updatePerson() {
              const { data, status } = await this.form.put('/api/user/dependant_persons')

                if (status === 200) {
                    this.$store.dispatch('responseMessage', {
                        type: 'success',
                        text: 'Guardado correctamente',
                        title: 'Correcto',
                        modal: false
                    })
                    this.cancelFormSubmit()
                    this.init();
                } else {
                    this.$store.dispatch('responseMessage', {
                        type: 'warning',
                        text: 'Error al guardar el registro',
                        title: 'Alerta',
                        modal: true
                    })
                }
            },
            editPerson(id) {
              this.editingPerson = true
              const personToEdit = this.persons.find(cost => cost.id === id)
              this.form = new Form({
                first_name: personToEdit.first_name,
                middle_name: personToEdit.middle_name,
                last_name_1: personToEdit.last_name_1,
                last_name_2: personToEdit.last_name_2,
                gender: personToEdit.gender,
                birth_date: personToEdit.birth_date,
                nit_type: personToEdit.nit_type,
                nit: personToEdit.nit,
                id: personToEdit.id,
              })
              this.dialog = true
            },
            deletePerson(id) {
              axios.delete(`/api/user/dependant_persons/${id}`)
                .then(resp => {
                  if (resp.status === 200) {
                    this.persons = this.persons.filter(person => person.id !== id)
                  }
                })
                .catch(error => console.log(error))
            },
            cancelFormSubmit() {
              this.dialog = false
              this.editingPerson = false
              this.form = new Form({
                first_name: '',
                middle_name: '',
                last_name_1: '',
                last_name_2: '',
                gender: '',
                birth_date: '',
                nit_type: '',
                nit: '',
              })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/user/dependant_persons.vue